import { render, staticRenderFns } from "./wxChatLogin.vue?vue&type=template&id=26edf6e6&scoped=true&"
import script from "./wxChatLogin.vue?vue&type=script&lang=js&"
export * from "./wxChatLogin.vue?vue&type=script&lang=js&"
import style0 from "./wxChatLogin.vue?vue&type=style&index=0&id=26edf6e6&lang=less&scoped=true&"
import style1 from "./wxChatLogin.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26edf6e6",
  null
  
)

export default component.exports